export var appConfig = {
  insaServiceAddress: "https://www.insa-support.com/InsaWebApi/api",
  authServiceAddress: "https://www.insa-support.com/InsaWebApi",
  //insaServiceAddress: "http://localhost:9000/api",
  //authServiceAddress: "http://localhost:9000",
  showPasswordChangeButtonOnLogin: true,
  showLanguageChangeButtonOnLogin: true,
  //loginText: "If you experience any problems logging in, please notify us at <a href=\"mailto:support@insa-software.com\"> support@insa-software.com</a>.",
  loginText:
    'To obtain login credentials, please contact us at <a href="mailto:support@insa-software.com"> support@insa-software.com</a>.',
  performanceChartSecondSerieName: "",
  portfolioGridSmallScreenColumns: [
    "SecName",
    "Quantity",
    "Currency",
    "CurrentPrice",
    "Valuation",
    "ProfitPerc",
  ],
  transactionsGridSmallScreenColumns: [
    "SecName",
    "QuantityWithoutCash",
    "TransAmountRC",
    "TransDate",
    "Description",
  ],
  hidePerformanceChartListColumn: true,
  clientSpecificColumnHidden: [],
  hideSecurityPricesVolume: false,
  sortTransactionsByDefault: false,
  multiSelectWidthSettings: false,
  dropdownWidthSettings: false,
  hideIncludeIgnoredTransactions: true,
  setCarouselTimeout: 10000,
  //pivotViewerServiceAddress: "http://137.117.218.210/InsaWebApi",
  pivotViewerServiceAddress: "https://www.insa-support.com/InsaWebApi",
  //pivotViewerServiceAddress: "http://localhost:9000",
  version: 3.11,
  showThemeSelection: true,
  menuShowRiskProfile: false,
  menuShowMainWindow: false,
  menuShowClientContacts: true,
  menuShowGenericForms: true,
  translationsVersion: 3.11,
  availableLocales: ["en-US", "de-DE", "es-ES", "it-IT", "hr-HR", "fr-FR"],
  allowTracking: true,
  SecMainClass_LIQUIDITY: 0,
  chartColors: [
    "#00dcfa",
    "#00b4c8",
    "#008ca0",
    "#005f69",
    "#004147",
    "#6C7071",
    "#555859",
    "#3A3D3D",
    "#202121",
  ],
  ClientTitle: "Online Portal",
  ActiveIsChecked: true,
  InsaCronAvailable: true,
  NavigateToReferrerOnLogout: true,
  portalLoginStatsAvaliable: false,
  menuShowNews: false,
  enableLockedCOlumnONPortfolioGrid: true,
  menuShowInsaTrader: false,
  useLegacyIcons: true,
};



// WEBPACK FOOTER //
// ./insaweb.default.PRODUCTION.config.ts